import React, {Component} from "react"
import LanguageSelect from "./LanguageSelect"
import {getCurrentYear} from "../constants"


class FooterPublic extends Component{

  changeLanguage = (event) => {
    this.props.changeLanguage(event.target.value)
  }

  render(){
    return (
      <div>
        <p className="m-t"> <small>Neeuro Pte Ltd &copy; {getCurrentYear()}</small> </p>

      </div>
    )
  }
}

export default FooterPublic



// WEBPACK FOOTER //
// ./src/components/FooterPublic.js